import {Box, Typography} from "@mui/material"
import React, { useEffect} from "react"
import {nanoid} from "nanoid"
import {getMerkmal} from "../../misc/widget-functions"
import Content from "../../components/Content"

const widgetFromMerkmalGenerator = (merkmal, pointer) => {
    const id = nanoid()
    return {
        id: id,
        label: merkmal.kurzname,
        x: 0,
        y: 1,
        w: 1,
        h: 1,
        type: "leafNode",
        component: merkmal.antworttyp,
        connections: {
            id: merkmal.id,
            treeName: "attributes",
            node: {
                ...merkmal,
                pointer,
            },
        },
        i: id,
        moved: false,
        static: false,
    }
}

const ContainerProduktsuche = ({container, getDataFromPointer, updateData}) => {
    const merkmal = getMerkmal(container)
    const data = getDataFromPointer(merkmal.pointer)
    const merkmale = data?.value?.map(entry => entry.origin) ?? []
    useEffect(() => {
        updateData({}, "/suche")
    }, [data])

    return (
        <Box
            display="grid"
            gridTemplateColumns="1fr 3fr"
            gap="5px"
            padding="5px"
            border="1px solid black"
        >
            {merkmale.map((merkmal, key) => (
                <>
                    <Typography>{merkmal.label || merkmal.kurzname}</Typography>
                    <Box>
                        <Content
                            widget={widgetFromMerkmalGenerator(
                                merkmal,
                                `/suche/${merkmal.id}`,
                            )}
                        />
                    </Box>
                </>
            ))}
        </Box>
    )
}

export default ContainerProduktsuche
